import { FORM_BUTTON_TYPES, FORM_FIELD_TYPES, FORM_VALIDATIONS } from '@whitbread-eos/atoms';
import { formatDataTestId } from '@whitbread-eos/utils';
import * as yup from 'yup';
export var resetPasswordFormConfig = _ref => {
  var _labels$login, _labels$login2, _labels$login3, _labels$login4, _labels$login5, _labels$login6;
  var getFormState = _ref.getFormState,
    defaultValues = _ref.defaultValues,
    defaultErrors = _ref.defaultErrors,
    onSubmit = _ref.onSubmit,
    baseDataTestId = _ref.baseDataTestId,
    labels = _ref.labels,
    resetForm = _ref.resetForm;
  var resetPasswordValidationSchema = yup.object().shape({
    email: yup.string().required((labels === null || labels === void 0 || (_labels$login = labels.login) === null || _labels$login === void 0 || (_labels$login = _labels$login.business) === null || _labels$login === void 0 ? void 0 : _labels$login.bookingLoginRequiredText) || (labels === null || labels === void 0 || (_labels$login2 = labels.login) === null || _labels$login2 === void 0 ? void 0 : _labels$login2.invalidEmail)).matches(FORM_VALIDATIONS.EMAIL.MATCHES, (labels === null || labels === void 0 || (_labels$login3 = labels.login) === null || _labels$login3 === void 0 || (_labels$login3 = _labels$login3.business) === null || _labels$login3 === void 0 ? void 0 : _labels$login3.bookingsInvalidEmailMsg) || (labels === null || labels === void 0 || (_labels$login4 = labels.login) === null || _labels$login4 === void 0 ? void 0 : _labels$login4.invalidEmail)).max(FORM_VALIDATIONS.EMAIL.MAX, (labels === null || labels === void 0 || (_labels$login5 = labels.login) === null || _labels$login5 === void 0 || (_labels$login5 = _labels$login5.business) === null || _labels$login5 === void 0 ? void 0 : _labels$login5.bookingEmailMaxLengthMsg) || (labels === null || labels === void 0 || (_labels$login6 = labels.login) === null || _labels$login6 === void 0 ? void 0 : _labels$login6.invalidEmail))
  });
  var config = {
    elements: {
      fieldsContainerStyles: {
        marginBottom: '1rem'
      },
      fields: [{
        type: FORM_FIELD_TYPES.INPUT_EMAIL,
        name: 'email',
        label: labels.forgottenPassword.leisure.emailPlaceholder,
        props: {
          useTooltip: true
        },
        testid: formatDataTestId(baseDataTestId, 'Email')
      }],
      buttons: [{
        type: FORM_BUTTON_TYPES.SUBMIT,
        label: labels.forgottenPassword.leisure.submitButton,
        action: onSubmit,
        styles: {
          marginBottom: '0'
        },
        props: {
          variant: 'primary',
          size: 'full'
        },
        testid: formatDataTestId(baseDataTestId, 'Submit')
      }]
    },
    defaultValues,
    validationSchema: resetPasswordValidationSchema,
    getFormState,
    defaultErrors,
    resetForm
  };
  return config;
};